import {$} from '../util/jq';

export default function initProducts() {
  $('.productCell').each(function (index) {
    const $product = $(this);

    //give product cells their action-type class names based on webId
    const webId = $product.attr('data-web-id');
    $product.addClass(webId);

    //remove addOn cart buttons
    $product.find('.addOns .product-footer').remove();

    //also make any product active that is checked for makeReferral
    if($product.find('.makeReferralCheckbox:checked').length){
      $product.addClass('item-active');
    }
  });

  $('.collapse-wrapper').each(function(i) {
    const collapse = $(this);
    const collapseHeader = collapse.find('[data-toggle]');
    const collapseContent = collapse.find('.collapse');

    collapseHeader.attr('href', '#collapse-' + i);
    collapseHeader.attr('aria-controls', 'collapse-' + i);
    collapseContent.attr('id', 'collapse-' + i);
  });
}



// WEBPACK FOOTER //
// ./src/main/js/pages/_initProducts.js